import { styled } from "../../../../../../styles";

export const DialysisTableContainer = styled("div", {
  width: "1000px",
  height: "550px",

  display: "flex",
  alignItems: "center",
  marginLeft: "-24px",

  fontSize: "14px",

  th: {
    zIndex: 1,
  },

  variants: {
    isPinnedGraph: {
      true: {
        width: "104.4%",
        height: "500px",
        marginLeft: "-32px",
      },
    },
  },
});
